module.exports = __webpack_public_path__ + "img/slide11.901bfc1b.png";